export default __webpack_public_path__ + "static/media/background.f39eab29.jpeg";